import normalize from "normalize.css";
import styles from '~/styles/main.scss';